module.exports = __webpack_public_path__ + "assets/icons/door.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/door.svg
// module id = o1sJ
// module chunks = 1